export class BookingSlotVelocityLimitOverride {

    constructor(
        public id: string,
        public startDateTime: Date,
        public bookingLimit: number | null,
        public coverLimit: number | null,
        public reasonId: string | null,
        public eventId: string | null
    ) { }

    occursOnDate(date: Date): boolean {
        return this.startDateTime.getFullYear() === date.getFullYear() &&
            this.startDateTime.getMonth() === date.getMonth() &&
            this.startDateTime.getDate() === date.getDate()
    }
}
